import React from 'react';
import { useLocation } from 'react-router-dom';
import { isSsr } from '@99designs/browser';
import { RedirectError } from '@99designs/routing';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { Site } from '@99designs/site-navigation/lib/Site';

const DOT_COM_DOMAIN = '99designs.com';

export default function DotComOnlyRoute({
    site,
    children,
}: {
    site: Site;
    children: React.ReactNode;
}) {
    const { pathname } = useLocation();
    if (site.getDomain() !== DOT_COM_DOMAIN) {
        const target = `https://${DOT_COM_DOMAIN}${pathname}`;
        // `window` does not exist during SSR, so calling window.location here would
        // throw and surface as a 500. Throw a RedirectError instead, which the SPA
        // server render loop converts into a real HTTP redirect (see spa server render.tsx).
        if (isSsr()) {
            throw new RedirectError(target);
        }
        window.location.replace(target);
        return null;
    }
    return <>{children}</>;
}
